export type AggregateWindow = '1mo' | '1h' | '1d' | '1w' | '1mo' | '1y' | '1m' | '1s'
export const NB_POINTS_MAX = 800
export interface FilterPoint{
    startDate?: string | null,
    stopDate?: string | null,
    aggregateWindow?: AggregateWindow | null

    device_name?: string | null
}


export interface Point {
    Value: number,
    Measurement: string,
    Time: string,
    Start: string,
    Stop: string,
    Field: string,
    Table: 0,
    Values: {
        _field: string,
        _measurement: string,
        _start: string,
        _stop: string,
        _time: string,
        _value: number,
        application_name: string,
        dev_eui: string,
        device_name: string,
        f_port: string,
        location: string,
        result: string,
        table: number,
        uuid: string
    }
}